import { FundOpportunityAdminFormData } from './types';

export function buildFundOpportunitySubmitPayload(formData: FundOpportunityAdminFormData) {
  return {
    name: formData?.name,
    fundSize: formData?.fundSize,
    fundDuration: formData?.fundDuration,
    interest: formData?.interest,
    lga: formData?.lga,
    returnOnInvestment: formData?.returnOnInvestment,
    siteArea: formData?.siteArea,
    summaryTitle: formData?.summaryTitle,
    currentValuation: formData?.currentValuation,
    seniorDebtLvr: formData?.seniorDebtLvr,
    closeDate: formData?.closeDate,
    security: formData?.security || null,
    capitalType: formData?.capitalType || null,
    sector: formData?.sector || [],
    interestType: formData?.interestType || null,
    facilityLimit: formData?.facilityLimit,
    excludeFromCustodian: formData?.excludeFromCustodian,
  };
}
